
/**
 * MySQL API Bridge Client
 * This service handles communication with the remote PHP MySQL bridge.
 */

const BRIDGE_URL = './mysql-bridge.php'; // Adjust path if hosted elsewhere

export const db = {
  async query(action: string, data: any = {}) {
    try {
      const response = await fetch(BRIDGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, ...data }),
      });
      
      const result = await response.json();
      if (!response.ok || result.error) {
        throw new Error(result.error || 'Database operation failed');
      }
      return result;
    } catch (error) {
      console.error(`MySQL Bridge Error (${action}):`, error);
      throw error;
    }
  }
};
